import 'ie-shim'; // Internet Explorer 9 support.

import 'core-js/es6';
import 'core-js/es7/reflect';

import 'zone.js/dist/zone';


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./app/polyfills.ts